import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Result } from '@digibricks/core';
import { Conversation, ConversationTitle, ConversationTag, MessageCount, TotalCost, TotalTokenUsed } from '../../../../core/domain/models';
import { AttachmentFileApiMapper } from './attachment-file-api.mapper';
export var ConversationApiMapper = /*#__PURE__*/function () {
  function ConversationApiMapper() {
    _classCallCheck(this, ConversationApiMapper);

    _defineProperty(this, "attachmentFileMapper", new AttachmentFileApiMapper());
  }

  _createClass(ConversationApiMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var titleResult = ConversationTitle.create(dto.title);
      if (titleResult.isFailure) return Result.fail(titleResult.error);
      var messageCountResult = MessageCount.create(dto.messageCount || 0);
      if (messageCountResult.isFailure) return Result.fail(messageCountResult.error);
      var totalCostResult = TotalCost.create(dto.totalCost || 0);
      if (totalCostResult.isFailure) return Result.fail(totalCostResult.error);
      var totalTokenUsedResult = TotalTokenUsed.create(dto.totalTokenUsed || 0);
      if (totalTokenUsedResult.isFailure) return Result.fail(totalTokenUsedResult.error);
      var tags = [];

      if (dto.tags) {
        var _iterator = _createForOfIteratorHelper(dto.tags),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var tagDto = _step.value;
            var tagResult = ConversationTag.create(tagDto.key, tagDto.value);

            if (tagResult.isSuccess) {
              tags.push(tagResult.getValue());
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var files = [];

      if (dto.files) {
        var _iterator2 = _createForOfIteratorHelper(dto.files),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var fileDto = _step2.value;
            var fileResult = this.attachmentFileMapper.toDomain(fileDto);

            if (fileResult.isSuccess) {
              files.push(fileResult.getValue());
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return Conversation.create({
        id: dto.id,
        title: titleResult.getValue(),
        status: dto.status,
        context: dto.context || '',
        skillId: dto.skillId,
        resourceId: dto.resourceId,
        resourceType: dto.resourceType,
        tags: tags,
        files: files,
        messageCount: messageCountResult.getValue(),
        totalCost: totalCostResult.getValue(),
        totalTokenUsed: totalTokenUsedResult.getValue(),
        lastMessageAt: dto.lastMessageAt
      });
    }
  }]);

  return ConversationApiMapper;
}();